import AppRouter from 'common/AppRouter';
import { useMemo } from 'react';
import { useHistory } from 'react-router';
import { PROGRESSION_COMPONENTS } from './useFiltersConfig';

const useWhichComponent = () => {
  const history = useHistory();
  const { pathname } = history.location;

  const whichComponent = useMemo(() => {
    if (pathname.includes(AppRouter.PROJECTS_FORECASTING_FORECAST.path))
      return PROGRESSION_COMPONENTS.FORECAST;
    if (pathname.includes(AppRouter.PROJECTS_FORECASTING_ROOT.path))
      return PROGRESSION_COMPONENTS.OVER_TIME;
  }, [pathname]);

  return whichComponent;
};

export default useWhichComponent;
